import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { sanitizeFileName } from "@sf-core";
import { ExportFileNames } from "../constants/exportFileNames";

export const getBenchmarkMicroSkillsCount = async () => {
  return base.get({
    url: `${API_PARAM.BENCHMARK_MICROSKILLS_COUNT}`,
  });
};

export const exportBenchmarkMicroSkillsGrid = async (filterModel) => {
  return base.exportFile({
    url: API_PARAM.BENCHMARK_MICROSKILLS_EXPORT,
    data: filterModel,
    fileName: sanitizeFileName(ExportFileNames.BENCHMARK_MICROSKILLS),    
  });
};

export const uploadBenchmarkJMicroSkills = async () => {
  return base.post({
    url: `${API_PARAM.BENCHMARK_MICROSKILLS_UPLOAD}`,
  });
};
